import { FC, JSX, useEffect, useMemo, useState } from 'react';
import Slider from 'components/commercetools-ui/atoms/slider';
import Typography from 'components/commercetools-ui/atoms/typography';
import useWindowWidth from 'helpers/hooks/useBrowerWidth';
import usePath from 'helpers/hooks/usePath';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { breakpoints } from 'helpers/utils/breakpoints';
import { desktop, hugeDesktop, largeDesktop, mediumDesktop, mobile, tablet } from 'helpers/utils/screensizes';
import ContentSliderSlide from './slide';
import { BrandProps, ContentSliderSlideProps } from './types';
const Brand: FC<BrandProps> = ({ data }) => {
  const { isTouchDevice } = useTouchDevice();
  const [hydrated, setHydrated] = useState(false);
  const path = usePath();
  const width = useWindowWidth();

  const section = data?.sections?.find((section: { multiple_info_section: any }) => section.multiple_info_section)
    ?.multiple_info_section?.multiple_info;

  const isTwoImageView = section?.length === 2;
  const isSectorPage = path.path.includes('/sectors/');
  const isLiveWellPage = path.path.includes('/caroma-livewell');
  const isBrandsPage =  path.path.includes('/brands');
  const isHomePage = path.path === '/';  

  useEffect(() => {
    setHydrated(true);
  }, []);
  const slidesElement = useMemo(() => {
    const slides = path.path.includes('brands') || path.path.includes('sectors') ? section : data?.global_card;

    return (
      slides?.map((data: JSX.IntrinsicAttributes & ContentSliderSlideProps, index: number) => (
        <ContentSliderSlide key={index} {...data} isTwoImage={isTwoImageView} />
      )) || null
    );
  }, [path.path, data?.sections, data?.global_card]);

  if (!hydrated) return null;

  const sectionTitle =
    data?.header?.section_title ||
    data?.sections
      ?.find((section: { multiple_info_section: any }) => section.multiple_info_section)
      ?.multiple_info_section?.multiple_info?.find((info: any) => info)?.title;

  const cmsCssClass =
    data?.additional_css ||
    data?.sections?.find((section: { multiple_info_section: any }) => section.multiple_info_section)
      ?.multiple_info_section?.additional_css;
  let slidesPerView = 4;
  if (isTwoImageView) {
    slidesPerView = 2;
  } else {
    if (isSectorPage) {
      slidesPerView = 5;
    } else {
      slidesPerView = 4;
    }
  }

  return (
    <div
      className={`${
        isTwoImageView ? 'brand-section' : ''
      } ${cmsCssClass} px-24 py-48 md:px-28 lg:px-48 xl:px-60 xl:pb-40  xl:pt-60 2xl:py-80 2xl:pl-61 2xl:pr-80 3xl:px-80`}
    >
      {sectionTitle && (
        <Typography
          className="relative mb-36 text-32 font-medium leading-8 text-[#090909] md:mb-48 xl:text-32 xl:leading-[2.25rem] 2xl:text-48 2xl:leading-[3.25rem]"
          as="h3"
        >
          {sectionTitle}
        </Typography>
      )}
      <Slider
        className=""
        dots={false}
        solidArrows={isLiveWellPage ? false : true}
        arrows={width !== null && width >= 1120}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        innerArrows={isLiveWellPage ? false : true}
        loop={isLiveWellPage ? false : true}
        allowArrowsOnTouchDevice={isLiveWellPage ? false : true}
        allowTouchMove={isTouchDevice}
        prevButtonStyles={{ padding: '20px', left: '-60px' }}
        nextButtonStyles={{ padding: '20px', right: '-60px' }}
        slidesPerView={isLiveWellPage ? 2 : width && width<=480 && isHomePage ?2.75: 3.75}
        spaceBetween={10}
        breakpoints={{
          [mobile]: {
            slidesPerView: isLiveWellPage ? 2 : isBrandsPage ? 2.15 :width && width<=480 && isHomePage ?2.75: 4,
            spaceBetween: 16,
            ...(breakpoints[tablet] ?? {}),
          },
          [tablet]: {
            slidesPerView: isLiveWellPage ? 2 : 3.15,
            spaceBetween: 16,
            ...(breakpoints[tablet] ?? {}),
          },
          [desktop]: {
            slidesPerView: isLiveWellPage ? 2 : slidesPerView,
            spaceBetween: 16,
            ...(breakpoints[desktop] ?? {}),
          },
          [mediumDesktop]: {
            slidesPerView: isLiveWellPage ? 2 : slidesPerView,
            spaceBetween: 16,
            ...(breakpoints[mediumDesktop] ?? {}),
          },
          [largeDesktop]: {
            slidesPerView: isLiveWellPage ? 2 : slidesPerView,
            spaceBetween: 16,
            ...(breakpoints[largeDesktop] ?? {}),
          },
          [hugeDesktop]: {
            slidesPerView: isLiveWellPage ? 2 : slidesPerView,
            spaceBetween: 16,
            ...(breakpoints[hugeDesktop] ?? {}),
          },
        }}
      >
        {slidesElement}
      </Slider>
    </div>
  );
};
export default Brand;

export * from './types';
